import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Page, Recovery, RecoveryForm } from '../models';

@Injectable()
export class RecoveryService {

    recoveriesUrl = environment.dns + 'api/recoveries/';

    constructor(private http: HttpClient) { }

    getPaginate(page: number, size: number): Observable<Page<Recovery>> {
        return this.http.get<Page<Recovery>>(this.recoveriesUrl + 'paginate?page=' + page + '&size=' + size);
    }

    getOne(id: number): Observable<Recovery> {
        return this.http.get<Recovery>(this.recoveriesUrl + id);
    }

    add(recoveryForm: RecoveryForm): Observable<Recovery> {
        return this.http.post<Recovery>(this.recoveriesUrl, recoveryForm);
    }

    update(recoveryForm: RecoveryForm): Observable<Recovery> {
        return this.http.put<Recovery>(this.recoveriesUrl, recoveryForm);
    }

    delete(id: number): Observable<boolean> {
        return this.http.delete<boolean>(this.recoveriesUrl + id);
    }
}